import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { request } from 'utils';
import { FETCH_UPDATE_DATE_REQUEST, FETCH_UPDATE_DATE_FAILURE, FETCH_UPDATE_DATE_SUCCESS } from 'actionTypes';
import { getUpdatedDateFetching, getUpdatedDateLoaded } from 'selectors';

var getShouldFetchUpdateDate = function getShouldFetchUpdateDate(state, props) {
  var isFetching = getUpdatedDateFetching(state, props);
  var isLoaded = getUpdatedDateLoaded(state, props);
  return !isFetching && !isLoaded;
};

export var fetchUpdatedDate = function fetchUpdatedDate(props) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, date;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              state = getState();

              if (getShouldFetchUpdateDate(state, props)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", true);

            case 4:
              dispatch({
                type: FETCH_UPDATE_DATE_REQUEST,
                payload: {}
              });
              _context.next = 7;
              return request("".concat(process.env.APP_PRODUCTS_API_ROOT, "date?product_type=11"));

            case 7:
              date = _context.sent;
              return _context.abrupt("return", dispatch({
                type: FETCH_UPDATE_DATE_SUCCESS,
                payload: {
                  date: date.updatedDate
                }
              }));

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", dispatch({
                type: FETCH_UPDATE_DATE_FAILURE,
                payload: {}
              }));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default fetchUpdatedDate();